import { render, staticRenderFns } from "./LabelSearchPage.vue?vue&type=template&id=4dde21fe"
import script from "./LabelSearchPage.vue?vue&type=script&lang=js"
export * from "./LabelSearchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports